import { useEffect, useRef, useState } from "react";
import CommonTable from "../../../components/comman/CommonTable";
import MainHeading from "../../../components/comman/MainHeading";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { MainFilterHandler } from "../../../components/comman/MainFilterHandler";
import { callApi } from "../../../ApiHelper/ApiHelper";
import moment from "moment";
import { toast } from "react-toastify";
import {
  Nav,
  NavItem,
  NavLink,
  Spinner,
  TabContent,
  Fade,
  TabPane,
} from "reactstrap";
import FilterComponent from "../../../components/comman/FilterComponent";
import { useDispatch, useSelector } from "react-redux";
import PlusIcon from "../../../components/Icons/PlusIcon";
import { RoutesLink } from "../../../ApiHelper/RoutesLink";
import EditIcon from "../../../components/Icons/EditIcon";
import ViewIcon from "../../../components/Icons/ViewIcon";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import ConfirmModal from "../../../components/comman/ConfirmModal";
import { formatAmount } from "../../../utility/CommonFunctions";
import {
  saveActivePtReimbTab,
  updateFiltersStates,
} from "../../../store/actions/UserActions";
import ExportDataHandler from "../../../utility/ExportDataHandler";

export default function PaymentTicketReimbursement() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isFirstYearChange, setIsFirstYearChange] = useState(true);
  const ActiveTab = useSelector((state) => state?.root?.activePtReimbTab);
  const filterDetails = useSelector((state) => state.root.filtersStates);
  const [pageStates, setPageStates] = useState({
    tableLoader: false,
    filterData: "",
    month: "",
    paymentTicketList: [],
    searchQuery: "",
    status: ActiveTab,
    type: "Reimbursement",
    siteId: filterDetails?.siteId,
    siteList: [],
    companyList: [],
    companyIsLoading: false,
    isLoadingSite: false,
    isInitial: true,
  });
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const [modal, setModal] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const timeoutId = useRef(null);
  const [ApprovedTabCounts, setApprovedTabCounts] = useState({
    totalCount: "",
    partCompleted: "",
    fullyCompleted: "",
  });

  const toggleModal = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (pageStates?.siteList?.length === 0) {
      GetSiteList();
    }
    if (filterDetails?.year) {
      GetPaymentTicket(filterDetails?.currentPage);
    }
  }, [
    filterDetails?.currentPage,
    ActiveTab,
    pageStates.searchQuery,
    filterDetails?.sortByDate,
    filterDetails?.year,
    filterDetails.pageSize,
    filterDetails?.siteId,
    pageStates?.status,
    filterDetails?.companyId,
    filterDetails?.orderBy,
    pageStates?.isInitial,
    filterDetails?.paymentStatus,
  ]);

  useEffect(() => {
    GetCompanyList();
  }, []);

  const GetPaymentTicket = (pageNo) => {
    let options = {
      method: "GET",
    };
    const filterData = {
      status: pageStates?.status,
      type: pageStates?.type,
      searchQuery: pageStates?.searchQuery,
      siteId: pageStates?.siteId,
      paymentStatus: ActiveTab == "approved" ? filterDetails?.paymentStatus : "",
      ...filterDetails,
    };
    const Url = apiUrl.get_payment_ticket + MainFilterHandler(filterData);
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(Url, options).then((res) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (res?.status === true) {
        const newData = res?.data?.paymentTicket?.map((item) => ({
          ...item,
          siteName: item?.site?.name,
          paymentDate: moment(item?.date).format("DD-MM-YYYY"),
          ExpenseMonth: item?.expenseMonth ? moment(item?.expenseMonth).format("MM/YYYY") : "--",
          createdBy: item?.user?.name,
          paymentTicketStatus: item?.status,
          grandTotal: formatAmount(item?.totalAmount),
          vendorName: item?.purchase?.vendor?.name,
          expenseName:
            item?.paymentticketexpenseheads[0]?.expensehead?.name +
            `${item?.paymentticketexpenseheads?.length > 1
              ? ` + ${item?.paymentticketexpenseheads?.length - 1}`
              : ""
            }`,
          remaining: formatAmount(item?.remainingAmount),
          paidAmount: formatAmount(item?.totalAmount - item?.remainingAmount),
        }));
        setApprovedTabCounts({
          totalCount: res?.data?.totalCount,
          partCompleted: res?.data?.partCompleted,
          fullyCompleted: res?.data?.fullyCompleted,
        });
        setPageStates((pre) => ({
          ...pre,
          paymentTicketList: newData,
        }));
        dispatch(
          updateFiltersStates({
            count: res?.data?.pageInfo?.total,
            totalPages: res?.data?.pageInfo?.totalPages,
          })
        );
      }
    });
  };

  const GetCompanyList = (inputValue) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_company}${inputValue ? `?search=${inputValue}` : ""
        }`;
      let options = { method: "GET" };
      setPageStates((prev) => ({
        ...prev,
        companyIsLoading: true,
      }));
      callApi(API, options)
        .then((response) => {
          if (response?.status) {
            const formattedData = response?.data?.company.map((company) => ({
              value: company.id,
              label: company.name,
            }));

            setPageStates((prev) => ({
              ...prev,
              companyIsLoading: false,
              companyList: formattedData,
            }));
            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          resolve([]);
        });
    });
  };

  const toggleTab = (tab) => {
    dispatch(saveActivePtReimbTab(tab));
    setPageStates((prev) => ({
      ...prev,
      status: tab,
    }));
    dispatch(
      updateFiltersStates({
        currentPage: 1,
        companyId: "",
      })
    );
    if (pageStates?.siteList?.length == 0) {
      GetSiteList();
    }
  };

  const TableHeadingGeneral = [
    { value: "ticketNumber", label: "Ticket Number" },
    { value: "siteName", label: "Site Name" },
    { value: "paymentDate", label: "Date" },
    { value: "ExpenseMonth", label: "Expense Month" },
    { value: "expenseName", label: "Expense Name" },
    { value: "createdBy", label: "Created By" },
    { value: "grandTotal", label: "Total Amount" },
    ...(ActiveTab === "approved"
      ? [{ value: "remaining", label: "Remaining  Amount" }]
      : []),
    ...(ActiveTab === "approved"
      ? [{ value: "paidAmount", label: "Paid  Amount" }]
      : []),
    ...(ActiveTab === "approved"
      ? [{ value: "paymentStatus", label: "Payment Status" }]
      : []),
    { value: "paymentTicketStatus", label: "Status" },
  ];

  const HandleView = (data) => {
    navigate(RoutesLink.payment_tickets_details + `/reimbursement/${data?.id}`);
  };

  const HandleUpdate = (data) => {
    navigate(RoutesLink?.create_reimbursement, { state: { data: data } });
  };

  const HandleDelete = () => {
    let options = {
      method: "GET",
    };
    let API = apiUrl.delete_payment_ticket + `?paymentTicketId=${selectedId}`;
    setIsLoading(true);
    callApi(API, options).then((response) => {
      setIsLoading(false);
      if (response?.status === true) {
        toast.success(response?.message);
        toggleModal("delete");
        GetPaymentTicket();
      } else {
        toast.error(response?.message);
        toggleModal("delete");
      }
    });
  };

  const ActionHandler = (data) => {
    setSelectedId(data?.id);
    toggleModal();
  };

  const ActionDataForPending = [
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
    ...(!(
      userDetails?.type === 2 ||
      userDetails?.designation?.name === "Coordinator"
    )
      ? [
        {
          label: "Edit",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "edit",
          clickHandler: HandleUpdate,
        },
      ]
      : []),
    {
      label: "Delete",
      className: "btn btn-link",
      icon: <DeleteIcon />,
      title: "delete",
      isShow: false,
      isSiteEditable: false,
      isVisible: "pending",
      type: userDetails?.type,
      loggedInUserId: userDetails?.id,
      clickHandler: ActionHandler,
    },
  ];

  const ActionData = [
    ...(userDetails?.type === 1 && userDetails?.department?.name === "Account"
      ? [
        {
          label: "Edit",
          className: "btn btn-link",
          icon: <EditIcon />,
          title: "edit",
          isShow: "Finance Created",
          isSiteEditable: false,
          isVisible: false,
          clickHandler: HandleUpdate,
        },
      ]
      : []),
    {
      label: "view",
      className: "btn btn-link",
      icon: <ViewIcon />,
      title: "view",
      clickHandler: HandleView,
    },
  ];

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= filterDetails?.totalPages) {
      dispatch(
        updateFiltersStates({
          currentPage: PageNo,
        })
      );
    }
  };

  const handleSearchChange = (e) => {
    const { value } = e.target;
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }
    timeoutId.current = setTimeout(() => {
      setPageStates((prevState) => ({
        ...prevState,
        searchQuery: value,
      }));
    }, 500);
  };

  const handleChangePageSize = (value) => {
    dispatch(
      updateFiltersStates({
        pageSize: value,
        currentPage: 1,
      })
    );
  };

  const dateChangeHandler = (Dates) => {
    // console.log(Dates);
    let formattedDate = null;
    if (Dates && Dates.length === 2) {
      const startDate = new Date(
        Dates[0].getTime() - Dates[0].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      const endDate = new Date(
        Dates[1].getTime() - Dates[1].getTimezoneOffset() * 60000
      )
        .toISOString()
        .slice(0, 10);
      formattedDate = [startDate, endDate];
    }
    // console.log(formattedDate);
    if (formattedDate !== null) {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    } else {
      dispatch(
        updateFiltersStates({
          sortByDate: formattedDate,
        })
      );
    }
  };

  const GetSiteList = (companyId = null, searchQuery = null) => {
    return new Promise((resolve) => {
      let API =
        userDetails?.type === 2
          ? apiUrl.get_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`
          : apiUrl.get_user_site +
          `?pageSize=${100}${companyId ? `&companyId=${companyId}` : ""}${searchQuery ? `&search=${searchQuery}` : ""
          }`;

      setPageStates((prev) => ({
        ...prev,
        isLoadingSite: true,
      }));

      callApi(API, { method: "GET" })
        .then((response) => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));

          if (response?.status) {
            const formattedData = response.data?.site?.map((item) => ({
              value: item?.site?.id || item.id,
              label: item?.site?.name || item.name,
            }));

            const isSitePresent = response.data?.site?.some((item) => {
              const id = item?.site?.id || item.id;
              return id == filterDetails?.siteId;
            });

            setPageStates((prev) => ({
              ...prev,
              ...(isSitePresent ? { isInitial: false } : { siteId: "" }),
              siteList: formattedData || [],
            }));

            resolve(formattedData);
          } else {
            resolve([]);
          }
        })
        .catch(() => {
          setPageStates((prev) => ({
            ...prev,
            isLoadingSite: false,
          }));
          resolve([]);
        });
    });
  };

  const sortList = {
    site: pageStates?.siteList,
    isShow: "show",
    ...(ActiveTab == "approved"
      ? {
        autoSiteSelector: () => {
          return (
            <div className="d-flex align-items-center gap-3 px-2">
              <select
                className="form-select pe-5"
                style={{ cursor: "pointer" }}
                onChange={(e) => {
                  dispatch(
                    updateFiltersStates({
                      paymentStatus: e.target.value,
                    })
                  );
                }}
                value={filterDetails?.paymentStatus ?? ""}
              >
                <option value={""} hidden>
                  Select Payment Status
                </option>
                <option value={""}>All</option>
                <option value={"pending"}>Pending</option>
                <option value={"completed"}>Full Payment</option>
                <option value={"partial"}>Part Payment</option>
              </select>
            </div>
          );
        },
      }
      : {}),
    companyList: pageStates?.companyList,
  };

  const handleSortData = (data, type) => {
    setPageStates((prevState) => ({
      ...prevState,
      ...(type === "site" && { siteId: data?.site }),
      ...(type === "companyId" && { companyId: data?.companyId }),
      ...(type == "companyId" && {
        siteId: "",
      }),
    }));
    dispatch(
      updateFiltersStates({
        ...(type === "site" && { siteId: data?.site }),
        ...(type == "companyId" && { companyId: data?.companyId, siteId: "" }),
      })
    );
  };

  const handleYearChange = (selectedYear) => {
    dispatch(
      updateFiltersStates({
        year: selectedYear,
        sortByDate: isFirstYearChange ? filterDetails.sortByDate : [],
      })
    );

    if (isFirstYearChange) {
      setIsFirstYearChange(false);
    }
  };

  const handleExport = () => {
    let filterData = {
      exportDataType: "paymentTicket",
      status: pageStates?.status,
      type: pageStates?.type,
      searchQuery: pageStates?.searchQuery,
      ...filterDetails,
    };
    delete filterData?.currentPage;
    delete filterData?.pageSize;
    delete filterData?.count;
    delete filterData?.totalPages;
    ExportDataHandler(filterData);
  };

  const orderByHandler = (e) => {
    dispatch(
      updateFiltersStates({
        orderBy: e.target.value,
      })
    );
  };

  const orderByList = [
    { value: "", name: "Newest" },
    { value: "asc", name: "Oldest" },
  ];

  return (
    <>
      <div className="content">
        <MainHeading
          title={"Payment Ticket - Reimbursement"}
          buttonText={"Create Payment Ticket"}
          buttonIcon={<PlusIcon />}
          buttonLink={
            userDetails?.designation?.canCreate?.includes("pt") &&
            RoutesLink?.create_reimbursement
          }
          dateChangeHandler={dateChangeHandler}
          handleYearChange={handleYearChange}
        />
        <Nav tabs className="nav nav-tabs border-0 mb-4">
          <NavItem className="nav-item">
            <NavLink
              className={
                ActiveTab === "pending"
                  ? "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2 active"
                  : "btn btn-outline-primary px-5 rounded-start-2 rounded-end-0 border-end-2 border-start-2"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("pending")}
            >
              Pending
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "approved"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-0 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("approved")}
            >
              Approved
            </NavLink>
          </NavItem>
          <NavItem className="nav-item ">
            <NavLink
              className={
                ActiveTab === "rejected"
                  ? "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0 active"
                  : "btn btn-outline-primary px-5 rounded-start-0 rounded-end-2 border-end-2 border-start-0"
              }
              style={{ cursor: "pointer" }}
              onClick={() => toggleTab("rejected")}
            >
              Rejected
            </NavLink>
          </NavItem>
        </Nav>
        <TabContent activeTab={ActiveTab}>
          <TabPane tabId={"pending"}>
            <Fade in={ActiveTab === "pending"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={
                      pageStates?.paymentTicketList?.length > 0
                        ? handleExport
                        : null
                    }
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingGeneral}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionDataForPending}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"approved"}>
            <Fade in={ActiveTab === "approved"} timeout={200}>
              <div className="d-flex gap-3 mb-3 align-items-center justify-content-between text-center">
                <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-between">
                  <h5 className="m-0">Total Payment Ticket </h5>
                  <h5 className="m-0">{ApprovedTabCounts?.totalCount}</h5>
                </div>
                <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-between">
                  <h5 className="m-0"> Part-Payment</h5>
                  <h5 className="m-0">{ApprovedTabCounts?.partCompleted}</h5>
                </div>
                <div className="d-flex align-items-center bg-body-secondary p-3 w-100 justify-content-between">
                  <h5 className="m-0"> Full-Payment </h5>
                  <h5 className="m-0">{ApprovedTabCounts?.fullyCompleted}</h5>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={
                      pageStates?.paymentTicketList?.length > 0
                        ? handleExport
                        : null
                    }
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingGeneral}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
          <TabPane tabId={"rejected"}>
            <Fade in={ActiveTab === "rejected"} timeout={200}>
              <div className="card mb-4">
                <div className="card-body">
                  <FilterComponent
                    handleSearch={handleSearchChange}
                    filterArray={sortList}
                    handleData={handleSortData}
                    pageStates={pageStates}
                    handleExport={
                      pageStates?.paymentTicketList?.length > 0
                        ? handleExport
                        : null
                    }
                    orderByHandler={orderByHandler}
                    orderByList={orderByList}
                    getSite={GetSiteList}
                    getCompany={GetCompanyList}
                  />
                  <CommonTable
                    TableHeading={TableHeadingGeneral}
                    TableData={pageStates?.paymentTicketList}
                    ActionData={ActionData}
                    currentPage={filterDetails?.currentPage}
                    PageChangeHandler={PageChangeHandler}
                    isLoading={pageStates?.tableLoader}
                    totalPages={filterDetails?.totalPages}
                    count={filterDetails?.count}
                    handleChangePageSize={handleChangePageSize}
                    pageSize={filterDetails.pageSize}
                  />
                </div>
              </div>
            </Fade>
          </TabPane>
        </TabContent>
      </div>
      <ConfirmModal
        modal={modal}
        toggle={() => toggleModal()}
        submitHandler={HandleDelete}
        isLoading={isLoading}
      />
    </>
  );
}
